/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { Maybe } from 'purify-ts';
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import * as utils from '@/utils';
import { valuePropNoError } from './utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function createSelect(name, options) {
    const unselected = Symbol(`unselected-${name}`);
    const component = tsx.componentFactoryOf().create({
        name: `form-select-${name}`,
        props: {
            value: valuePropNoError().required,
            default: p.ofType().optional,
            optionVisible: p.ofFunction().optional,
            disabled: p(Boolean).default(false),
            disableUnselected: p(Boolean).default(false),
        },
        computed: {
            // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
            maybeDefault() {
                return Maybe.fromNullable(this.default).join();
            },
        },
        methods: {
            // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
            onInput(value) {
                const maybeValue = value === unselected ? Maybe.empty() : Maybe.of(value);
                tsx.emitOn(this, 'onInput', maybeValue);
            },
            // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
            renderEmptyOption() {
                return (<b-form-select-option value={unselected} disabled={this.disableUnselected}>
                        {utils.renderScopedSlot({}, this.$scopedSlots.emptyOption, () => 'Please select an option')}
                    </b-form-select-option>);
            },
            // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
            renderOption(option) {
                if (this.optionVisible != null && !this.optionVisible(option)) {
                    return utils.emptyVNode();
                }
                return (<b-form-select-option value={option.value}>
                        {utils.renderScopedSlot({ option }, this.$scopedSlots.option, d => utils.coerceToString(d.option.value))}
                    </b-form-select-option>);
            },
            // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
            renderOptions() {
                return [
                    utils.ifOrEmpty(this.maybeDefault.isNothing(), () => this.renderEmptyOption()),
                    options.map(option => this.renderOption(option)),
                ];
            },
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        render() {
            const maybeValue = this.value;
            return (<b-form-select value={maybeValue.alt(this.maybeDefault).orDefault(unselected)} onInput={this.onInput} disabled={this.disabled}>
                    {this.renderOptions()}
                </b-form-select>);
        },
    });
    return component;
}
